export default {
  drawer: null,
  screenSize: null,
  offsetTop: 51
}
